import { useState } from "react";
import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import RankSection from "@/pages/home/components/RankSection";
import CategorySection from "@/pages/home/components/CategorySection";
import UpdateSection from "@/pages/home/components/UpdateSection";
import FeaturedSection from "@/pages/home/components/FeaturedSection";
import ReviewSection from "@/pages/home/components/ReviewSection";
import FaqSection from "@/pages/home/components/FaqSection";
import Footer from "@/pages/home/components/Footer";
import BackToTop from "@/pages/home/components/BackToTop";

export default function Home() {
  const [keyword, setKeyword] = useState("");
  const [category, setCategory] = useState("全部");

  const handleSearch = (kw: string) => {
    setKeyword(kw);
    setCategory("全部");
  };

  const handleCategory = (name: string) => {
    setCategory(name);
    setKeyword("");
    document.getElementById("update")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <Navbar />
      <main>
        <Hero onSearch={handleSearch} />
        <RankSection />
        <CategorySection onSelect={handleCategory} />
        <UpdateSection initialKeyword={keyword} initialCategory={category} />
        <FeaturedSection />
        <ReviewSection />
        <FaqSection />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}